module.exports = __webpack_public_path__ + "img/2f_r_tonya@2x.ad49107e.png";